import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../../../hooks/use-auth';

interface GuestGuardProps {
  children: ReactNode;
}

export const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated, tenant } = useAuth();

  if (isAuthenticated) {
    let redirectPath = '/events';

    if (tenant?.publicMetadata?.demoMode?.enabled) {
      redirectPath = '/items';
    }

    return <Navigate to={redirectPath} />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};
